namespace Roodik.Game
{
	import ViewBase = Roodik.Core.ViewBase;
	import Easing = Roodik.Core.Tween.Easing;
	import Tween = Roodik.Core.Tween.Tween;
	import Timer = Roodik.Core.Timer;
	import IStorageManager = Roodik.Core.IStorageManager;
	import ISoundManager = Roodik.Core.ISoundManager;

	export class TutorialView extends ViewBase
	{
		private _hided:boolean = true;
		private _timer:Timer;
		private _timeSpent:number = 0;
		private _tutorialData:TutorialData;

		constructor(private _soundManager:ISoundManager, private _storageManager:IStorageManager)
		{
			super("TutorialArrow");

			let ss = this._storageManager.loadData("tutorial-data");
			this._tutorialData = ss ? JSON.parse(ss) : new TutorialData();

			this.playChildAnimation("HandAnimation", "animtion0");
			this.stopChildAnimation("HandAnimation", "animtion0");

			this.alpha = 0;

			if (this._tutorialData.canShowSkeleton)
			{
				this._timer = new Timer(()=>{
					this._timeSpent++;
					if (this._timeSpent >= 5)
					{
						this._timer.stop();
						this.show();
					}
				});
				this._timer.stop();
			}

		}

		public run()
		{
			if (this._tutorialData.canShowSkeleton)
			{
				this._timer.start();
			}
		}

		public reset()
		{
			this._timeSpent = 0;
		}

		private show()
		{
			if (this._tutorialData.canShowSkeleton)
			{
				if (!this._hided)
				{
					return;
				}
				this._soundManager.playSound("tutorShow.wav", 0.5);

				this._hided = false;
				this.playChildAnimation("HandAnimation", "animtion0");

				let properties = {alpha:this.alpha};
				new Tween(properties)
				.to({alpha: 1}, 150)
				.easing(Easing.Quadratic.In)
				.onUpdate(()=>{
					this.alpha = properties.alpha;
				})
				.start();
			}
		}

		public hide()
		{
			if(this._tutorialData.canShowSkeleton)
			{
				if (this._hided)
				{
					return;
				}
				this._hided = true;

				this.stopChildAnimation("HandAnimation", "animtion0");

				let properties = {alpha:this.alpha};
				new Tween(properties)
				.to({alpha: 0}, 150)
				.easing(Easing.Quadratic.In)
				.onUpdate(()=>{
					this.alpha = properties.alpha;
				})
				.onComplete(()=>{
					this.doNotShowSkeleton();
				})
				.start();
			}
		}

		public doNotShowSkeleton()
		{
			this._tutorialData.canShowSkeleton = false;
			this._storageManager.saveData("tutorial-data", JSON.stringify(this._tutorialData));
		}

		public destroy()
		{
			this.stopChildAnimation("HandAnimation", "animtion0");
			if (this._timer != null)
			{
				this._timer.stop();
				this._timer.destroy();
				this._timer = null;
			}

			super.destroy();
		}
	}

	export class TutorialData
	{
		canShowSkeleton : boolean = true;
	}
}


// WEBPACK FOOTER //
// /source/src/typescript/Game/View/TutorialView.ts